export default class XAPI
{
    async save() {}

    async createVoice(dataTextVoice, locale, force=false) {}

    async importImage(dataImage) {}
    async importVideo(dataVideo) {}
}

